import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { gotoSearchResults, SEARCH_RESTAURANTS_TYPE_RESTAURANT_ID, SEARCH_RESTAURANTS_TYPE_RESTAURANT_NAME, SEARCH_RESTAURANTS_TYPE_POOL_ID } from '../../../actions/restaurantSearch'
import PropTypes from 'prop-types'

const SEARCH_TYPES = [
  { value: SEARCH_RESTAURANTS_TYPE_RESTAURANT_ID, name: "Restaurant ID" },
  { value: SEARCH_RESTAURANTS_TYPE_RESTAURANT_NAME, name: "Restaurant Name" },
  { value: SEARCH_RESTAURANTS_TYPE_POOL_ID, name: "Pool ID" }
]

export class SearchInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      searchText: props.searchText || '',
      searchType: SEARCH_TYPES.some(st => st.value === props.searchType)
        ? props.searchType
        : SEARCH_TYPES[0].value
    }
  }

  onSearchTextChange(event) {
    this.setState({ searchText: event.target.value })
  }

  onSearchTypeChange(event) {
    this.setState({ searchType: event.target.value })
  }

  render() {
    let placeHolderText = this.state.searchType === SEARCH_RESTAURANTS_TYPE_RESTAURANT_ID ? "Restaurant Search by ID"
      : this.state.searchType === SEARCH_RESTAURANTS_TYPE_RESTAURANT_NAME ? "Restaurant Search by Name"
        : this.state.searchType === SEARCH_RESTAURANTS_TYPE_POOL_ID ? "Restaurant Search by Pool ID (use 'No pool' for missing mappings)"
          : "Search text"

    let gotoSearchResultWithState = () => this.props.gotoSearchResults(this.state.searchText, this.state.searchType)
    return <div className="row">
      <div className="col-lg-6 col-md-8 col-sm-12">
        <div className="input-group mb-3">
          <select
            name="searchType"
            value={this.state.searchType}
            className="form-control"
            onChange={this.onSearchTypeChange.bind(this)}
            style={{ maxWidth: '11rem' }}>
            {SEARCH_TYPES.map(st => <option key={st.value} value={st.value}>{st.name}</option>)}
          </select>
          <input name={this.state.searchType === SEARCH_RESTAURANTS_TYPE_RESTAURANT_ID ? "idSearchText" : "nameSearchText"}
            type="text"
            className="form-control" onChange={this.onSearchTextChange.bind(this)}
            onKeyPress={(e) => e.key === 'Enter' ? gotoSearchResultWithState() : null}
            placeholder={placeHolderText}
            value={this.state.searchText} />
          <div className="input-group-append">
            <button id="btnSearch" className="btn btn-primary" onClick={gotoSearchResultWithState.bind(this)}>Search</button>
          </div>
        </div>
      </div>
    </div>
  }
}

SearchInput.propTypes = {
  searchText: PropTypes.string,
  searchType: PropTypes.string,

  gotoSearchResults: PropTypes.func,
}

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => bindActionCreators({
  gotoSearchResults,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchInput)



// WEBPACK FOOTER //
// ./src/containers/restaurants/search/searchInput.js